export const selectLanguage = (state) => state.language.language;
export const selectVersion = (state) => state.language.version;
export const selectLanguageContent = (state) => state.language.languageContent;
export const selectAllowChange = (state) => state.language.allowChange;
